import { ImageOff, Loader2 } from 'lucide-react';
import { useEffect, useMemo, useState } from 'react';
import { useModelPreview } from '@/api/hooks';
import { cn } from '@/utils/cn';

export const ModelPreviewImage = ({
  modelId,
  alt,
  className,
}: {
  modelId: string | undefined;
  alt: string;
  className?: string;
}): React.ReactElement => {
  const { data: previewBlob, isLoading } = useModelPreview(modelId);

  const [decoded, setDecoded] = useState(false);

  const previewUrl = useMemo(() => (previewBlob ? URL.createObjectURL(previewBlob) : null), [previewBlob]);

  // Reset decoded state when the URL changes (new image)
  useEffect(() => {
    setDecoded(false);
  }, []);

  useEffect(() => {
    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

  if (isLoading) {
    return (
      <div className={cn('flex items-center justify-center', className)}>
        <Loader2 size={16} className="animate-spin text-slate-400" />
      </div>
    );
  }

  if (previewUrl) {
    return (
      <img
        src={previewUrl}
        alt={alt}
        className={cn('object-contain', !decoded && 'invisible', className)}
        onLoad={() => setDecoded(true)}
      />
    );
  }

  return (
    <div className={cn('flex items-center justify-center text-slate-400', className)}>
      <ImageOff size={20} />
    </div>
  );
};
